module.exports = __webpack_public_path__ + "static/coffee-66850_1280-a8a5ff3f3d0440c0303477ce82dc5d50.png";